/* PILSNERISH OS — product gallery (R5): one viewport-fit stage + selector.
 * The stage is a scroll-snap track: touch swipes it natively, trackpads scroll it natively, a mouse drags it (R6),
 * and [<] [>], thumbnails, the dots and the arrow keys move it at every width. Only the active slide +/- 1 get their image sources (after the page load event, or at once when the
 * visitor asks for a slide). Videos play only while their slide is active and the stage is on screen (pz-core
 * applies the intro skips). Variant changes jump to the variant's image ('pz:media' from pz-product.js).
 * Markup: sections/main-product.liquid + snippets/pz-pdp-slide.liquid. CSS: pz-product.css.
 */
(function () {
  'use strict';
  var w = window, d = document;
  var PZ = w.PZ;
  if (!PZ || !PZ.onSection) return;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  PZ.onSection('pdp-gallery', function (g) {
    var track = g.querySelector('[data-pz-track]');
    if (!track) return null;
    var slides = [].slice.call(track.children);
    var n = slides.length;
    var thumbsEl = g.querySelector('[data-pz-thumbs]');
    var thumbs = [].slice.call(g.querySelectorAll('[data-pz-thumb]'));
    var dots = [].slice.call(g.querySelectorAll('.pz-pdp__dot'));
    var count = g.querySelector('[data-pz-count-cur]');
    var prevBtn = g.querySelector('[data-pz-prev]');
    var nextBtn = g.querySelector('[data-pz-next]');
    var pdp = g.closest('.pz-pdp') || g.parentNode;
    var offs = [];
    function on(t, ev, fn, o) { t.addEventListener(ev, fn, o); offs.push(function () { t.removeEventListener(ev, fn, o); }); }

    var active = 0, loaded = d.readyState === 'complete', visible = true, pending = -1, pendingT = 0, raf = 0;

    /* stage height = screen space under the header at load: measure the real offset (status bar or not) */
    function measureTop() {
      var top = Math.round(pdp.getBoundingClientRect().top + w.scrollY);
      if (top > 0 && top < w.innerHeight * 0.5) pdp.style.setProperty('--pdp-top', top + 'px');
    }
    measureTop();

    function hydrate(i) {
      var s = slides[i];
      if (!s) return;
      s.querySelectorAll('img[data-pz-defer]').forEach(function (im) {
        if (im.getAttribute('data-srcset')) im.setAttribute('srcset', im.getAttribute('data-srcset'));
        if (im.getAttribute('data-src')) im.setAttribute('src', im.getAttribute('data-src'));
        im.removeAttribute('data-pz-defer');
        im.loading = 'eager';
      });
    }
    function hydrateAround(i, force) {
      if (force) hydrate(i);
      if (!loaded) return;
      hydrate(i); hydrate(i + 1); hydrate(i - 1);
      if (i === n - 1) hydrate(0);
      if (i === 0) hydrate(n - 1);
    }

    function syncVideos() {
      slides.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (!v) return;
        if (PZ.reduced) { v.controls = true; return; }
        if (k === active && visible) {
          v.muted = true;
          if (PZ.hushVideo) PZ.hushVideo(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }

    function keepThumbInView(t) {
      if (!thumbsEl || !t) return;
      var vertical = thumbsEl.scrollHeight > thumbsEl.clientHeight + 1 && getComputedStyle(thumbsEl).flexDirection === 'column';
      if (vertical) {
        var top = t.offsetTop - thumbsEl.offsetTop, bot = top + t.offsetHeight;
        if (top < thumbsEl.scrollTop) thumbsEl.scrollTop = top - 10;
        else if (bot > thumbsEl.scrollTop + thumbsEl.clientHeight) thumbsEl.scrollTop = bot - thumbsEl.clientHeight + 10;
      } else {
        var left = t.offsetLeft - thumbsEl.offsetLeft, right = left + t.offsetWidth;
        if (left < thumbsEl.scrollLeft) thumbsEl.scrollLeft = left - 16;
        else if (right > thumbsEl.scrollLeft + thumbsEl.clientWidth) thumbsEl.scrollLeft = right - thumbsEl.clientWidth + 16;
      }
    }

    function setActive(i) {
      if (i === active) return;
      active = i;
      slides.forEach(function (s, k) {
        var onK = k === i;
        s.classList.toggle('is-on', onK);
        if (onK) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      dots.forEach(function (dt, k) {
        dt.classList.toggle('is-on', k === i);
        if (k === i) dt.setAttribute('aria-current', 'true'); else dt.removeAttribute('aria-current');
      });
      if (count) count.textContent = pad(i + 1);
      keepThumbInView(thumbs[i]);
      hydrateAround(i, true);
      syncVideos();
    }

    function go(i, instant) {
      if (n < 2) return;
      i = (i + n) % n;
      hydrate(i);
      pending = i;
      clearTimeout(pendingT);
      pendingT = setTimeout(function () { pending = -1; }, 900);
      track.scrollTo({ left: i * track.clientWidth, behavior: instant || PZ.reduced ? 'auto' : 'smooth' });
      setActive(i);
    }

    /* swipe / trackpad: the snapped slide becomes active (ignoring the slides a programmatic scroll passes) */
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (drag) return;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        i = Math.max(0, Math.min(n - 1, i));
        if (pending > -1) { if (i === pending) { pending = -1; clearTimeout(pendingT); } return; }
        setActive(i);
      });
    }
    on(track, 'scroll', onScroll, { passive: true });

    if (prevBtn) on(prevBtn, 'click', function () { go(active - 1); });
    if (nextBtn) on(nextBtn, 'click', function () { go(active + 1); });
    thumbs.forEach(function (t, k) { on(t, 'click', function () { go(k); }); });
    /* R6: dots are buttons */
    dots.forEach(function (dt, k) { on(dt, 'click', function () { go(k); }); });

    /* R6: mouse drag (touch keeps the native swipe; trackpads scroll the track natively and it snaps). Snap is off
       while dragging; on release a drag past 15% of the width, or a quick flick, moves one slide. */
    var drag = null, dragMoved = false;
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var dx = (e && typeof e.clientX === 'number' ? e.clientX : drag.lx) - drag.x;
      var dt = performance.now() - drag.t;
      var i = active;
      if (Math.abs(dx) > track.clientWidth * 0.15 || (Math.abs(dx) > 30 && dt < 260)) i = active + (dx < 0 ? 1 : -1);
      i = Math.max(0, Math.min(n - 1, i));
      try { track.releasePointerCapture(drag.id); } catch (err) {}
      dragMoved = drag.moved;
      drag = null;
      track.classList.remove('is-dragging');
      go(i);
    }
    if (n > 1) {
      on(track, 'pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = { id: e.pointerId, x: e.clientX, lx: e.clientX, sl: track.scrollLeft, t: performance.now(), moved: false };
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.classList.add('is-dragging');
      });
      on(track, 'pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        drag.lx = e.clientX;
        if (Math.abs(dx) > 3) drag.moved = true;
        track.scrollLeft = drag.sl - dx;
      });
      on(track, 'pointerup', endDrag);
      on(track, 'pointercancel', endDrag);
      on(track, 'dragstart', function (e) { e.preventDefault(); });
      /* trackpad / shift-wheel: one horizontal gesture = one slide (native scrolling of a wide stage could stop
         short of the halfway point and snap back) */
      var wAcc = 0, wLock = false, wT = 0;
      on(track, 'wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        clearTimeout(wT);
        wT = setTimeout(function () { wAcc = 0; wLock = false; }, 220);
        if (wLock) return;
        wAcc += e.deltaX;
        if (Math.abs(wAcc) > 40) {
          wLock = true;
          var to = active + (wAcc > 0 ? 1 : -1);
          if (to >= 0 && to < n) go(to);
        }
      }, { passive: false });
      /* a drag is not a click */
      on(track, 'click', function (e) { if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; } }, true);
    }

    /* arrow keys: while the gallery is on screen and the visitor is not typing or choosing an option */
    on(d, 'keydown', function (e) {
      if (n < 2 || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if (d.documentElement.classList.contains('pz-locked')) return;
      var r = g.getBoundingClientRect();
      if (r.bottom < 80 || r.top > w.innerHeight - 80) return;
      e.preventDefault();
      go(active + (e.key === 'ArrowRight' ? 1 : -1));
    });

    /* variant picked in the buy box -> its image */
    on(g, 'pz:media', function (e) {
      var id = String(e.detail && e.detail.id);
      for (var k = 0; k < n; k++) {
        if (slides[k].getAttribute('data-media-id') === id) {
          go(k);
          var r = g.getBoundingClientRect();
          if (r.bottom < 120) PZ.scrollTo(g, { offset: -(PZ.headerOffset() + 8) });
          return;
        }
      }
    });

    /* keep the active slide snapped when the stage resizes */
    var rt = 0;
    on(w, 'resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { track.scrollTo({ left: active * track.clientWidth, behavior: 'auto' }); }, 80);
    });

    offs.push(PZ.inView(g, function (inside) { visible = inside; syncVideos(); }, { media: false, threshold: 0.15 }));

    function onLoad() { loaded = true; measureTop(); hydrateAround(active, false); }
    if (loaded) onLoad(); else on(w, 'load', onLoad, { once: true });

    syncVideos();
    return function () {
      clearTimeout(pendingT); clearTimeout(rt);
      if (raf) cancelAnimationFrame(raf);
      offs.forEach(function (f) { try { f(); } catch (e) {} });
      slides.forEach(function (s) { var v = s.querySelector('video'); if (v) v.pause(); });
    };
  });
})();
